import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from '@blueprintjs/core';
import { Colors, Classes, Elevation, Position } from '@blueprintjs/core';
import styled from 'styled-components';

import { setSelectedProject, setProjectSelectVisible } from '$root/store/actions';


export const ProjectSelectList = styled.div`
    display: flex;
    flex-flow: row wrap;
    list-style-type: none;
    margin: 0;
    padding: 1rem;
    gap: 1rem;
`;


export const ProjectSelectListItem = styled.div.attrs(props => ({
    paddingVertical: props.paddingVertical || 6,
    fontSize: props.fontSize || '100%',
}))`
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    margin: 4px;
    padding: ${props => `${props.paddingVertical}px`} 4px;
    background-color: white;
    transition: all 0.2s ease-in-out ;
    cursor: pointer;
    font-size: ${props => props.fontSize};
    ${props => props.selected && `
        font-weight: bold;
    `}
    &:hover {
        transition: all 0.2s ease-in-out;
        border-color: #BBBBBB;
        background-color: #EEEEEE;
        box-shadow: 2px 2px 3px -1px rgba(0,0,0,0.5);
    }
`;


const Placeholder = styled.div.attrs(props => ({
}))`
    //@keyframes animatedBackground {
    //    from {
    //        background-position: -400px 0;
    //    }
    //    to {
    //        background-position: 400px 0;
    //    }
    //}
    //
    border: 1px solid transparent;
    border-radius: 8px;
    margin: 0 0 20px 0;
    //background-size: 800px 256px;
    //background-image: linear-gradient(
    //        90deg,
    //        #eeeeee 0%,
    //        #cccccc 10%,
    //        #eeeeee 20%,
    //        #eeeeee 100%
    //);
    //background-position: 0 0;
    //background-repeat: repeat;
    //animation: animatedBackground 4s linear infinite;
`;


export default function ProjectSelect(props) {

    const dispatch = useDispatch();
    const availableProjects = useSelector(state => state.project.availableProjects)
    const selectedProject = useSelector(state => state.project.selectedProject)

    const [ projectSelectItems, setProjectSelectItems ] = useState([]);

    useEffect(() => {
        setProjectSelectItems((availableProjects || []).map(project => {
            const current = true; ///project.id === props.selectedProjectId;
            return (
                <Card
                    key={project.id}
                    interactive={true}
                    elevation={Elevation.TWO}
                    onClick={() => {
                        dispatch(setSelectedProject(project));
                        dispatch(setProjectSelectVisible(false));
                    }}
                >
                    <Placeholder className={Classes.SKELETON} style={{ width:256, height:160 }}/>
                    {selectedProject?.id === project.id &&
                        <span><b>{project.name}</b></span>
                    }
                    {selectedProject?.id !== project.id &&
                        <span>{project.name}</span>
                    }
                </Card>);
        }));
    }, [availableProjects, selectedProject, setProjectSelectItems, setProjectSelectVisible]);

    return (
        <>
            {/*<editor-fold desc="Project selector">*/}
            <ProjectSelectList>
                {projectSelectItems}
            </ProjectSelectList>
            {/*</editor-fold>*/}
        </>
    );
}